// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A4ts","select":"styles_select__3p9hw"};